import React from 'react'
import { Col, Row } from 'react-bootstrap'
import WeatherCard from './Card'

export default class Weather extends React.Component {
  constructor (props) {
    super(props)
    this.props = props
    this.state = {}
  }

  render () {
    if (!this.state.weather) return
    return (
      <>
        <hr />
        <h1 className='mb-4'>Local Weather</h1>
        <Row className='row-cols-1 row-cols-lg-3'>
          {this.state.weather.map(area => {
            return (
              <Col key={area.name}>
                <WeatherCard area={area} />
              </Col>
            )
          })}
        </Row>
      </>
    )
  }

  componentDidMount () {
    this.socket = window.io('/weather', { transports: ['websocket'] })
    this.socket.on('update', weather => this.setState({ weather }))
  }
}
